import { PaginatedDataSheetLogisticsEstimates } from '@lune-fe/dapi-models'
import { TableNew } from '@lune-fe/lune-ui-lib'
import moment from 'moment'
import { FC, RefObject } from 'react'

import { formatNumberWithFallback } from 'utils'
import {
    DataSheetEstimateContextMenu,
    EmissionCalculationRow,
    EstimateTypeName,
    EstimateTypeSlug,
} from 'views/CalculateEmissions'
import { formatLocation } from 'views/CalculateEmissions/Shared/utils'

type DataSheetLogisticsEstimate = PaginatedDataSheetLogisticsEstimates['data'][0]

const SelectableDataSheetLogisticsRow: FC<{
    calculation: DataSheetLogisticsEstimate
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
    isSelected: boolean
    onSelectChange: (checked: boolean) => void
}> = ({ calculation, currentPage, queryParams, pageHistoryRef, isSelected, onSelectChange }) => {
    const estimateType = calculation.estimateType
    const slug = EstimateTypeSlug(estimateType)

    const formatDate = (date: string) => {
        return moment(date).format('ll')
    }

    return (
        <EmissionCalculationRow
            id={calculation.id}
            slug={slug}
            emissionType={EstimateTypeName(estimateType)}
            estimateType={estimateType}
            contextMenu={<DataSheetEstimateContextMenu quantity={calculation.mass.amount} />}
            currentPage={currentPage}
            pageHistoryRef={pageHistoryRef}
            queryParams={queryParams}
            showCheckbox={true}
            isSelected={isSelected}
            onCheckboxChange={onSelectChange}
        >
            <TableNew.TableCell colSize={2} oneLineText>
                {formatLocation(calculation.source)}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {formatLocation(calculation.destination)}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {calculation.isShipment ? 'Shipment' : 'Pre-shipment'}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {formatDate(calculation.shipmentAt)}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={2} oneLineText>
                {calculation.numLegs}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1} oneLineText>
                {formatNumberWithFallback(calculation.mass.amount, {
                    decimals: 2,
                    decimalsWhenLessThan: 6,
                    fallback: '--',
                })}
            </TableNew.TableCell>
        </EmissionCalculationRow>
    )
}

export default SelectableDataSheetLogisticsRow
